<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{$t('language.new')}}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="grid.search"
                    append-icon="search"
                    :label="$t('language.search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>{{$t('language.dealer')}}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.name"
                                :label="$t('language.name')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <ValidationProvider
                              :name="$t('language.email')"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.emailaddress"
                                :label="$t('language.email')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field v-model="vModel.company" :label="$t('language.company')" />
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              v-model="vModel.contactperson"
                              :label="$t('language.contactperson')"
                            />
                          </v-flex>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              v-model="vModel.contactphone"
                              :label="$t('language.contactphone')"
                            />
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="grey darken-1"
                        text
                        @click="closedialog"
                      >{{$t('language.cancel')}}</v-btn>
                      <v-btn color="blue darken-1" text type="submit">{{$t('language.save')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-dialog v-model="dialog1" max-width="300px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(resetPassword)">
                  <v-card>
                    <v-card-title>{{$t('language.resetpassword')}}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <ValidationProvider
                              :name="$t('language.password')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                type="password"
                                v-model="respwdvModel.password"
                                :label="$t('language.password')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="grey darken-1"
                        text
                        @click="closedialog"
                      >{{$t('language.cancel')}}</v-btn>
                      <v-btn color="blue darken-1" text type="submit">{{$t('language.save')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.name>
                <span>{{$t("language.name")}}</span>
              </template>
              <template v-slot:header.emailaddress>
                <span>{{$t("language.email")}}</span>
              </template>
              <template v-slot:header.company>
                <span>{{$t("language.email")}}</span>
              </template>
              <template v-slot:header.contactperson>
                <span>{{$t("language.contactperson")}}</span>
              </template>
              <template v-slot:header.contactphone>
                <span>{{$t("language.contactphone")}}</span>
              </template>
              <template v-slot:header.action>
                <span>{{$t("language.actions")}}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.id)">edit</v-icon>
                <v-icon small class="mr-2" @click="deleteItem(item.id)">delete</v-icon>
                <v-icon small @click="showdialog1(item.id)">vpn_key</v-icon>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Base from "../../shared/Base.vue";
import axios from "axios";
export default {
  name: "dealerview",
  extends: Base,
  data() {
    return {
      dialog1: false,
      respwdvModel: {
        password: null,
        id: null
      }
    };
  },
  created() {
    this.grid.headers = [
      { value: "name" },
      { value: "emailaddress" },
      { value: "company" },
      { value: "contactperson" },
      { value: "contactphone" },
      { value: "action", sortable: false }
    ];
    this.vModel = {
      id: null,
      name: null,
      emailaddress: null,
      company: null,
      contactperson: null,
      contactphone: null
    };
    this.url = "admin/dealers";
  },
  methods: {
    closedialog1() {
      if (!this.dialog1) return;
      this.dialog1 = false;
      setTimeout(() => {
        this.respwdvModel.id = null;
        this.respwdvModel.password = null;
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      }, 300);
    },
    showdialog1(itemid) {
      this.respwdvModel.id = itemid;
      console.log(this.respwdvModel);
      this.dialog1 = true;
      setTimeout(() => {
        this.respwdvModel.password = null;
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      }, 300);
    },
    resetPassword() {
      if (this.loading) return;
      this.loading = true;
      console.log(this.respwdvModel);
      var axiosHandler = axios.post(
        "admin/dealers/reset/password",
        this.respwdvModel
      );
      axiosHandler.then(
        () => {
          this.$store.dispatch(
            "showSuccessMessage",
            this.$t("language.passwordsetsuccessful")
          );

          this.closedialog1();
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }
};
</script>